import { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  LOCATION_SEARCH_DATA_LOCAL_STORAGE_KEY,
  LOCATION_SEARCH_DATA_CHANGE_EVENT,
} from '../../constants';
import { LocationSearchData } from '../../types';
import { setLocation } from '../../redux/locationReducer';

const loadLsData = (): LocationSearchData | undefined => {
  const stringified = localStorage.getItem(LOCATION_SEARCH_DATA_LOCAL_STORAGE_KEY);

  if (!stringified) return undefined;

  try {
    const parsed = JSON.parse(stringified) as LocationSearchData;

    return parsed;
  } catch (e) {
    return undefined;
  }
};

const useLocationSearchData = () => {
  const dispatch = useDispatch();
  const [locationSearchData, setLocationSearchData] = useState<LocationSearchData | undefined>(
    loadLsData,
  );

  const onLocationSearchDataChanged = useCallback(() => {
    setLocationSearchData(loadLsData);
  }, []);

  // Effect responsible for adding/removing event listener
  useEffect(() => {
    document.addEventListener(LOCATION_SEARCH_DATA_CHANGE_EVENT, onLocationSearchDataChanged);

    return () => {
      document.removeEventListener(LOCATION_SEARCH_DATA_CHANGE_EVENT, onLocationSearchDataChanged);
    };
  }, [onLocationSearchDataChanged]);

  useEffect(() => {
    if (!locationSearchData) return;
    dispatch(setLocation(locationSearchData));
  }, [dispatch, locationSearchData]);
};

export default useLocationSearchData;
